import React from "react";
import { Spinner } from "reactstrap";

export function ShowLoadingScreen() {
  return (
    <div
      className="d-flex flex-column w-100 justify-content-center align-items-center"
      style={{ height: "calc(100vh - 3px)" }}
    >
      <Spinner style={{ width: "3rem", height: "3rem" }} />
    </div>
  );
}
